import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import PurchaseTransactionsList from './PurchaseTransactionsList';
import { PurchaseTransactionsHubProvider } from './PurchaseTransactionsHubContext';

const DRAWER_OPEN_PATTERN =
  /^\/purchase-transactions\/(view\/|bill\/|payment\/)/;

const PurchaseTransactionsLayout = () => {
  const { pathname } = useLocation();
  const overlayOpen = DRAWER_OPEN_PATTERN.test(pathname);

  return (
    <PurchaseTransactionsHubProvider>
      <div className="h-screen w-full bg-gray-100 flex overflow-hidden">
        <Sidebar />
        <main className="flex-1 flex flex-col min-h-0 overflow-hidden p-4 md:p-6 relative">
          <div
            className={`flex-1 flex flex-col min-h-0${
              overlayOpen ? ' pointer-events-none select-none opacity-60' : ''
            }`}
            aria-hidden={overlayOpen}
          >
            <PurchaseTransactionsList />
          </div>
          <Outlet />
        </main>
      </div>
    </PurchaseTransactionsHubProvider>
  );
};

export default PurchaseTransactionsLayout;
